import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutManualOpenItemProcessingPrePostReview extends Layout {
    labelOpenItemCount: Label;
    labelOpenItemCountCaption: Label;
    labelPrePostReview: Label;
    labelTotalAmount: Label;
    labelTotalAmountCaption: Label;
    panelMulticurrencyTotals: Panel;
    panelPrePostReview: Panel;
    sourceGetManualOpenItemTotals: DataSource;
}
